import { FC, useEffect, useState } from "react";
import { FunctionalityButton } from "../FunctionalityButton";
import { VerticalStack } from "../../../components/Stack";
import { IStackStyles, Text } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { functionalityState } from "../../redux/DocumentStackSlice";
import { colorPallete } from "../../../assets/color";
import "./index.css";
import useIsSignedIn from "../../../hooks/useIsSignedIn";
import { ProjectService } from "../../../services/ProjectService";
import { formatMoney } from "../../../utils";

const verticalStackStyles: IStackStyles = {
  root: {
    minHeight: "9rem",
    width: "100%",
    backgroundColor: "",
    justifyContent: "space-evenly",
    marginTop: "1%",
  },
};

interface PipelineItemProps {
  title: string;
  value: string | number;
}
const PipelineItem: FC<PipelineItemProps> = ({
  title,
  value,
}: PipelineItemProps) => {
  return (
    <div
      style={{
        border: "1px solid grey",
        borderRadius: "0.4rem",
        height: "90px",
        padding: "8px 0px",
        width: "150px",
        backgroundColor: "white",
      }}
    >
      <div
        style={{
          // height: "20%",
          borderBottom: "1px solid grey",
          textAlign: "center",
          color: "grey",
          fontWeight: "bolder",
        }}
      >
        {title}
      </div>
      <div
        style={{
          // height: "80%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "xx-large",
        }}
      >
        {value}
      </div>
    </div>
  );
};
interface PipelineProps {
  items: PipelineItemProps[];
}
const Pipeline: FC<PipelineProps> = ({ items }: PipelineProps) => {
  return (
    <div style={{ width: "fit-content", padding: "8px", alignSelf: "center" }}>
      <div
        style={{
          height: "20%",
          textAlign: "center",
          marginBottom: "4px",
          fontSize: "x-large",
        }}
      >
        My Pipeline
      </div>
      <div style={{ display: "flex", gap: "10px" }}>
        {items.map((item, index) => {
          return (
            <PipelineItem key={index} title={item.title} value={item.value} />
          );
        })}
      </div>
    </div>
  );
};
const demoItem = [
  {
    title: "Active",
    value: 1000,
  },
  {
    title: "Closed",
    value: 1000,
  },
  {
    title: "Value",
    value: "$1.4B",
  },
];
export const FunctionalityButtonStack: FC = () => {
  const [activeState, setActiveState] = useState(false);

  const click2 = () => {};
  const dispatch = useDispatch();
  function click() {
    dispatch(functionalityState("draft"));
  }

  function click1() {
    // dispatch(functionalityState("negotiate"));
  }
  const { t } = useTranslation();
  const [statuses, setStatuses] = useState([
    t("draft"),
    t("negotiate"),
    t("sign"),
  ]);
  const isSignedIn = useIsSignedIn();
  useEffect(() => {
    const fetchStatuses = async () => {
      try {
        if (isSignedIn) {
          const currentStatus: any = await ProjectService.getStatuses();
          setStatuses([
            `Active - ${currentStatus.data.activeCount}`,
            `Closed - ${currentStatus.data.closedCount}`,
            `Closed Projects Value - ${formatMoney(
              currentStatus.data.closedValue
            )}`,
            `Active Projects Value - ${formatMoney(
              currentStatus.data.activeValue
            )}`,
          ]);
        } else {
          setStatuses([t("draft"), t("negotiate"), t("sign")]);
        }
      } catch (error) {
        console.error("Error fetching statuses:", error);
      }
    };

    fetchStatuses();
  }, [isSignedIn]);

  return (
    <VerticalStack styles={verticalStackStyles}>
      <div className="ButtonStack">
        <FunctionalityButton
          buttonText={t("draft")}
          color={colorPallete.btBlue}
          onClickFunction={click}
          flex={"1 1 30vw"}
          icon="draft"
        />
        <FunctionalityButton
          buttonText={t("negotiate")}
          color={colorPallete.btGreen}
          onClickFunction={click1}
          flex={"1 1 30vw"}
          icon="negotiate"
        />
        <FunctionalityButton
          buttonText={t("sign")}
          color={colorPallete.btRed}
          onClickFunction={click2}
          flex={"1 1 30vw"}
          icon="sign"
        />
      </div>
    </VerticalStack>
  );
};
